import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface ErrorDialogOptions {
  label: string;
  errorDetail?: string;
  onRetry?: () => Promise<void>;
}

interface ErrorDialogState extends ErrorDialogOptions {
  open: boolean;
}

interface ErrorDialogContextValue {
  state: ErrorDialogState;
  openErrorDialog: (opts: ErrorDialogOptions) => void;
  closeErrorDialog: () => void;
}

const ErrorDialogContext = createContext<ErrorDialogContextValue>(null!);

export function useErrorDialog() {
  return useContext(ErrorDialogContext);
}

export function ErrorDialogProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ErrorDialogState>({ open: false, label: '' });

  const openErrorDialog = useCallback((opts: ErrorDialogOptions) => {
    setState({ open: true, ...opts });
  }, []);

  const closeErrorDialog = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  return (
    <ErrorDialogContext.Provider value={{ state, openErrorDialog, closeErrorDialog }}>
      {children}
    </ErrorDialogContext.Provider>
  );
}
